import React, {Component} from 'react';
import BrandResults from './BrandResults';
import Loading from '../Shared/Loading';
import './brand.css';
import CampaignModal from "../Modal/Campaign";
import BrandModal from "../Modal/Brand";
import {fetchBrand, updateBrandSort} from "../../actions/brandActions";
import connect from "react-redux/es/connect/connect";
import AccessControl from '../../utils/AccessControl';
import caretDown from '../../assets/caret-down.svg';
import SVG from "react-inlinesvg";
import queryString from 'query-string';
import lock from '../../assets/lock-480x480.png';
import ToolTips from "../Shared/ToolTips";
import {addSearchFilter, fetchSearchResults} from "../../actions/searchActions";
import {getCreativeInfo} from "../../actions/campaignActions";
import CampaignModalContainer from "../Modal/campaignModalContainer";

class Brand extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            showModal: {
                campaign: false
            }
        };
        this.toggleModal = this.toggleModal.bind(this);
        this.handleSortClick = this.handleSortClick.bind(this);
        this.getSortClass = this.getSortClass.bind(this);
    }

    componentDidMount() {
        let query = this.props.location.search;
        let queryParams = queryString.parse(query);
        if (typeof queryParams.sort_col === 'string' && typeof queryParams.sort_dir === 'string') {
            this.props.dispatch(updateBrandSort(queryParams.sort_col, queryParams.sort_dir));
        } else {
            this.props.dispatch(updateBrandSort(false,false));
        }
        this.props.dispatch(fetchBrand(this.props.match.params.bid)).then((res)=>{
            if(this.props.permission === false){
                this.props.history.push('/unauthorized');
            }
        });
        this.props.dispatch(getCreativeInfo());
    }

    componentDidUpdate(prevProps) {
        if((prevProps.sort_dir !== this.props.sort_dir || prevProps.sort_col !== this.props.sort_col) && !this.props.loading){
            this.props.dispatch(fetchBrand(this.props.match.params.bid));
        }
    }

    toggleModal(show, key) {
        this.setState({
            showModal: {
                [key] : show
            }
        })
    }


    getSortClass = (column) => {
        let classes = 'sort-column';
        if (this.props.sort_col === column) {
            classes += ' active';
        }
        if(this.props.sort_dir === ""){
            classes += ' sort-desc';
        } else {
            classes += ' sort-' + this.props.sort_dir;
        }
        return classes;
    };

    handleSortClick = (column) => {
        let direction = this.props.sort_dir === 'asc' ? 'desc' : 'asc';
        this.props.dispatch(updateBrandSort(column, direction));
        let url = '/brand/' + this.props.match.params.bid;
        if (typeof column === 'string' && typeof direction === 'string') {
            url += `?sort_col=${column}&sort_dir=${direction}`;
        }
        this.props.history.push(url)
    };
    displayComponent = () => {
        const campaign = this.props.creative_info;
        if(this.state.showModal.campaign){
            return(
                <CampaignModalContainer
                    user={this.props.user}
                    toggleModal={this.toggleModal}
                    create={false}
                    modal={this.state.showModal}
                    inputOptions={this.props.creative_info.meta}
                    stages='brandPage'
                    brand={this.props.brand}
                    fullUserFlow={true}
                />
            )
        }
    }

    render() {
        return (
            <div>
                {this.displayComponent()}
                {this.state.showModal.brand && <BrandModal
                    toggleModal={this.toggleModal}
                    create={true}
                    brand={this.props.brand}
                />}
                {this.props.loading ?  <Loading /> :
                    <div>
                        <div className="brand-campaign-header">
                            <div>
                                {this.props.brand.hide_brand === 1 ? <span id="lock-container"><ToolTips content="Hidden Brand" data="hb"><img src={lock} alt="brand is hidden"/></ToolTips></span> : ""}
                                <h1>{this.props.brand.name}</h1>
                                {this.props.campaign.length > 0 &&
                                <div className="brand-campaign-meta">
                                    <div className="brand-campaign-verticals">{this.props.brand.verticals.map(v => v.name).join(', ')}</div>
                                </div>
                                }
                            </div>
                            <AccessControl
                                userPermissions={this.props.user.roles}
                                allowedPermissions={['editor', 'admin']}
                            >
                                <div className="brand-header-edit">
                                    <div><button className="button button--blue-outline button--medium" onClick={() => this.toggleModal(true, "campaign")}>Add Campaign
                                    </button></div>
                                    <button className="button button--blue" onClick={() => this.toggleModal(true, 'brand')}>Edit
                                        Brand
                                    </button>
                                </div>
                            </AccessControl>
                        </div>
                        <div className="campaign-info">
                            <div className="search-table-wrapper">
                                <table className="table table-sort b-table-wrapper">
                                    <thead>
                                    <tr>
                                        <th className="creative-tr">Creative</th>
                                        <th className={this.getSortClass('campaign')}>Campaign Name
                                        </th>
                                        <th>Creative Format</th>
                                        <th className={this.getSortClass('date')}  onClick={() =>this.handleSortClick('date') }>Date
                                            <span className="caret">
                                                <SVG src={caretDown}/>
                                            </span>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.props.campaign.map(brand => (
                                        <BrandResults key={brand.id} campaign={brand} />
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                </div>
                }
            </div>
        )
    }
}

const mapStateToProps = state => ({
    creative_info: state.campaign,
    campaign: state.brand.campaign,
    brand: state.brand.brand,
    sort_col: state.brand.sort_col,
    sort_dir: state.brand.sort_dir,
    loading: state.brand.loading,
    user: state.user,
    permission: state.brand.permission
});

export default connect(mapStateToProps)(Brand);
